import React from "react";
import "./ProfileDataText.scss";

export function ProfileDataText(props) {
  const { children } = props;

  return <div className="profile-data-text">{children}</div>;
}
